export default __webpack_public_path__ + "static/media/back.6bf1d124.svg";